import { render, staticRenderFns } from "./MypageTicketTodayListSection.vue?vue&type=template&id=38b0634e&scoped=true"
import script from "./MypageTicketTodayListSection.vue?vue&type=script&lang=ts"
export * from "./MypageTicketTodayListSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageTicketTodayListSection.vue?vue&type=style&index=0&id=38b0634e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b0634e",
  null
  
)

export default component.exports